module.exports = __webpack_public_path__ + "media/images/sponsorBox__bg-cb77672056d2d2b1727c4fa278cfc69b.jpg";